import { render, staticRenderFns } from "./InvestigationsTable.vue?vue&type=template&id=4f5b1375&scoped=true&"
import script from "./InvestigationsTable.vue?vue&type=script&lang=js&"
export * from "./InvestigationsTable.vue?vue&type=script&lang=js&"
import style0 from "./InvestigationsTable.vue?vue&type=style&index=0&id=4f5b1375&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5b1375",
  null
  
)

export default component.exports